/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

// Модель совместной покупки
(function () {
  'use strict';

  app.JointPurchase = app.Model.extend({
    urlRoot: app.entryScriptName + '/api/v3/jp-purchase',

    url: function () {
      return this.urlRoot + '/' + this.get('id') + '/';
    },
    /**
     * Добавить заявку к заказу
     * @param {int} id айди заявки
     */
    addRequestToOrder: function (id) {
      var orderIds = this._getOrderIdsArray();
      orderIds.push(id);
      this._saveSelectedOrders(orderIds);
    },
    /**
     * Удалить заявку из заказа
     * @param {int} id айди заявки
     */
    removeRequestFromOrder: function (id) {
      var orderIds = this._getOrderIdsArray();

      orderIds = _.filter(orderIds, function (order_id) {
        return order_id !== id;
      });
      this._saveSelectedOrders(orderIds);
    },

    /**
     * Сохранить список выбранных заявок
     * @param orderIds
     * @private
     */
    _saveSelectedOrders: function (orderIds) {
      var requests = orderIds.join(',');
      this.save({
        jp_purchase_selected_order_ids: requests
      });
    },

    /**
     * Получить массив номеров заявок
     * @private
     * @returns {Array} массив номеров
     */
    _getOrderIdsArray: function () {
      var orderIds = _.map(this.selectedOrders, 'order_id');
      return orderIds;
    },
  });
})();

}.call(window));